import { Input, message, Modal } from "antd";
import EmptyScreen from "../empty-screen/EmptyScreen";
import { Button1, SuccessTag, PendingTag, FailedTag } from "../index";
import { useState } from "react";
import { referralApi } from "../../api/endpoints";
import { useReferralInvites } from "../../data/live";

const statusTag = (status) => {
  if (status === "ACCEPTED") return <SuccessTag tagName={status} className="rounded-2" />;
  if (status === "SENT") return <PendingTag tagName={status} className="rounded-2" />;
  return <FailedTag tagName={status || "UNKNOWN"} className="rounded-2" />;
};

const MyInvites = () => {
  const [openModal, setModalOpen] = useState(false);
  const [inviteeEmail, setInviteeEmail] = useState("");
  const [inviteeName, setInviteeName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { invites, loading, refresh } = useReferralInvites();

  const handleInvite = async () => {
    if (!inviteeEmail.trim()) return;
    setSubmitting(true);
    try {
      await referralApi.createInvite({
        inviteeEmail: inviteeEmail.trim(),
        inviteeName: inviteeName.trim() || undefined,
      });
      await refresh();
      setInviteeEmail("");
      setInviteeName("");
      setModalOpen(false);
      message.success("Invite sent");
    } catch (error) {
      message.error(error.response?.data?.error || "Failed to send invite");
    } finally {
      setSubmitting(false);
    }
  };

  const emptyScreenButton = (
    <Button1
      buttonName={"Invite Contact"}
      className={"btn-dark"}
      onClick={() => setModalOpen(true)}
    />
  );

  return (
    <>
      <Modal
        title={<span className="fs-5 fw-semibold">Send invite via email</span>}
        open={openModal}
        width={"650px"}
        centered
        okText={submitting ? "Sending..." : "Send Invite"}
        okButtonProps={{ className: "bg-black text-white rounded-pill" }}
        cancelButtonProps={{
          className: "rounded-pill",
          style: { color: "red", borderColor: "red" },
        }}
        onOk={handleInvite}
        onCancel={() => setModalOpen(false)}
        confirmLoading={submitting}
      >
        <div className="d-flex flex-column gap-3 p-3">
          <div className="d-flex flex-column gap-2">
            <label className="fs12px">Invite contact</label>
            <Input
              className="p-3"
              placeholder="Enter email"
              value={inviteeEmail}
              onChange={(e) => setInviteeEmail(e.target.value)}
            />
          </div>

          <div className="d-flex flex-column gap-2">
            <label className="fs12px">Name</label>
            <Input
              className="p-3"
              placeholder="Your Name"
              value={inviteeName}
              onChange={(e) => setInviteeName(e.target.value)}
            />
          </div>
        </div>
      </Modal>

      <div className="border p-3 rounded-3">
        <div className="d-flex justify-content-end mb-3">
          <Button1
            buttonName={"Invite Contact"}
            className={"btn-dark"}
            onClick={() => setModalOpen(true)}
          />
        </div>

        {loading ? (
          <div className="p-5 text-center text-muted">Loading invites...</div>
        ) : invites.length ? (
          <div className="d-flex flex-column gap-2">
            {invites.map((invite) => (
              <div
                key={invite.id}
                className="d-flex justify-content-between align-items-center border rounded-3 p-3 flex-wrap gap-2"
              >
                <div className="d-flex flex-column">
                  <span className="fw-semibold">
                    {invite.inviteeName || invite.inviteeEmail}
                  </span>
                  <span className="fs12px" style={{ color: "#7D7D7D" }}>
                    {invite.inviteeEmail}
                  </span>
                </div>
                {statusTag(invite.status)}
              </div>
            ))}
          </div>
        ) : (
          <EmptyScreen
            message={
              "A list of your successful and pending invites will be shown here"
            }
            heading={"Invite your first contact"}
            moreContent={emptyScreenButton}
            className={"gap-3"}
          />
        )}
      </div>
    </>
  );
};

export default MyInvites;
